var _rect, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgVbsTreeView(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_18377_352859",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 25
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_18377_352859)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13 9.19588C12.45 9.19588 11.9792 9.00049 11.5875 8.60838C11.1958 8.21627 11 7.7465 11 7.19588V5.5C11 4.94938 11.1958 4.47961 11.5875 4.0875C11.9792 3.69539 12.45 3.5 13 3.5H18.9998C19.5498 3.5 20.0206 3.69539 20.4123 4.0875C20.804 4.47961 20.9998 4.94938 20.9998 5.5V7.19588C20.9998 7.7465 20.804 8.21627 20.4123 8.60838C20.0206 9.00049 19.5498 9.19588 18.9998 9.19588L13 9.19588ZM13 7.19588L18.9998 7.19588V5.5L13 5.5V7.19588Z",
    fill: "#212945"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13 21.6959C12.45 21.6959 11.9792 21.5005 11.5875 21.1084C11.1958 20.7163 11 20.2465 11 19.6959V18C11 17.4494 11.1958 16.9796 11.5875 16.5875C11.9792 16.1954 12.45 16 13 16H18.9998C19.5498 16 20.0206 16.1954 20.4123 16.5875C20.804 16.9796 20.9998 17.4494 20.9998 18V19.6959C20.9998 20.2465 20.804 20.7163 20.4123 21.1084C20.0206 21.5005 19.5498 21.6959 18.9998 21.6959L13 21.6959ZM13 19.6959L18.9998 19.6959V18L13 18V19.6959Z",
    fill: "#212945"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13 15.4459C12.45 15.4459 11.9792 15.2505 11.5875 14.8584C11.1958 14.4663 11 13.9965 11 13.4459V11.75C11 11.1994 11.1958 10.7296 11.5875 10.3375C11.9792 9.94539 12.45 9.75 13 9.75H18.9998C19.5498 9.75 20.0206 9.94539 20.4123 10.3375C20.804 10.7296 20.9998 11.1994 20.9998 11.75V13.4459C20.9998 13.9965 20.804 14.4663 20.4123 14.8584C20.0206 15.2505 19.5498 15.4459 18.9998 15.4459L13 15.4459ZM13 13.4459L18.9998 13.4459V11.75L13 11.75V13.4459Z",
    fill: "#212945"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5 21.6914C4.45 21.6914 3.97917 21.4956 3.5875 21.1039C3.19583 20.7122 3 20.2414 3 19.6914V5.5C3 4.95 3.19583 4.47917 3.5875 4.0875C3.97917 3.69583 4.45 3.5 5 3.5H8C8.55 3.5 9.02083 3.69583 9.4125 4.0875C9.80417 4.47917 10 4.95 10 5.5V19.6914C10 20.2414 9.80417 20.7122 9.4125 21.1039C9.02083 21.4956 8.55 21.6914 8 21.6914H5ZM5 19.6914H8V5.5H5V19.6914Z",
    fill: "#212945"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVbsTreeView);
export default __webpack_public_path__ + "static/media/vbs-tree-view.4cb9e3af84606952f490fb50ada1241b.svg";
export { ForwardRef as ReactComponent };